<template>
  <div>
    <CatSubtitle v-if="isSupportedGrade"
      :title="'common.sam_assignment'"
      :eventLabel="'cat'"
      :routeName="'cat-domain-view'"
      class="cl-container" />

    <div class="domain-list">
      <div class="dummy-domain" v-if="busy">
        <div>
          <div class="dummy-domain-subject"></div>
          <div class="dummy-domain-title"></div>
          <div class="dummy-domain-action"></div>
        </div>
      </div>

      <template v-else>
        <div v-if="!isSupportedGrade" class="not-support-grade">
          <div class="title px-0">
            {{ $t('common.sam_assignment') }}
            <img 
              src="/static/images/ic-info-outline-black.svg"
              alt="classting-score" 
              v-b-modal.previewDomainModal
            />
          </div>
          <div class="sub-title px-0">
            <span>{{ $t('common.not_support_grade') }}</span>
          </div>
        </div>

        <EmptyContent v-else-if="catDomains.length === 0"
          :emptyContentText="$t('common.empty_domain_assignment')" />

        <div v-else
          class="domain" 
          v-for="(value, index) in catDomains" 
          :key="index">
          <div class="domain-subject">
            <img
              :src="value.icon_url"
              :style="{ 'background': value.color_code }"
              alt="subject-icon"
            />
            <span>{{ value.name }}</span>
          </div>
          <div class="domain-title">
            {{ value.domain_name }}
          </div>
          <div class="row">

            <template v-if="value && !value.cat">
              <div class="col-12 domain-action" v-bind:style="{ color: value.color_code}">
                <span v-on:click="openCreatedLearningViewer(value.domain_id, true)">
                  {{ $t('common.first_problem_solve') }} &gt;
                </span>
              </div>
            </template>

            <template v-else-if="value.cat && value.cat.is_completed">
              <div class="col-6 domain-score">
                <strong v-bind:style="{ color: value.color_code }">
                  {{ $t('common.score') }} 
                  <span v-bind:style="{ color: value.color_code }">
                    {{ value.proficiency_score || 0 }}{{ $t('common.score_value') }}
                  </span>
                </strong>
              </div>
              <div class="col-6 domain-action" v-bind:style="{ color: value.color_code}">
                <span v-on:click="openCreatedLearningViewer(value.domain_id, false)">
                  {{ $t('common.problem_solve') }} &gt;
                </span>
              </div>
            </template>

            <template v-else-if="value.cat && value.cat.is_first_cat">
              <div class="col-6 domain-score">
                <strong v-bind:style="{ color: value.color_code }">
                  {{ quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count) }}%
                </strong>
              </div>
              <div class="col-6 domain-action"
                v-bind:style="{ color: value.color_code}">
                <span v-on:click="openLearningViewer(value.cat && value.cat.viewer_url, true)">
                  {{ $t('common.continu_solve') }} &gt;
                </span>
              </div>
              <div class="col-12 domain-progress-bar">
                <progress-bar :value="quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count)" 
                  :bgColor="value.color_code" 
                  :height="6"
                  :isBorderStyle="true" />
              </div>
            </template>

            <template v-else-if="value.cat && !value.cat.is_completed">
              <div class="col-6 domain-score">
                {{ $t('common.score') }} 
                <span v-bind:style="{ color: value.color_code }">
                  {{ value.proficiency_score || 0 }}{{ $t('common.score_value') }}
                </span>
              </div>
              <div class="col-6 domain-action"
                v-bind:style="{ color: value.color_code}">
                <span v-on:click="openLearningViewer(value.cat && value.cat.viewer_url)">
                  {{ $t('common.continu_solve') }} &gt;
                </span>
              </div>
            </template>

          </div>
        </div>
      </template>

      <PrimeModal v-if="isPrimeModal"
        @closeModal="closePrimeModal()"
        @okModal="okPrimeModal()"
        :benefitTitle="$t('prime.first_solve_complete')"
        :isUnsupportText="true" />

      <LicenceModal v-if="isLicenceModal"
        @ok="isLicenceModal = false" />

      <b-modal
        id="previewDomainModal"
        class="preview-domain-modal"
        ref="modal"
        centered
        hide-header
        hide-footer
      >
        <slot>
          <div class="preview-domain">
            <div class="preview-domain-header">{{ $t('common.not_support_grade' )}}</div>
            <div class="preview-domain-body">
              <img src="/static/images/img_sample_sam.png" alt="icon" />
            </div>
            <div class="preview-domain-footer">
              <button
                type="button"
                @click="handleCloseClick"
              >
                {{ $t('common.confirmation') }}
              </button>
            </div>
          </div>
        </slot>
      </b-modal>

    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { isEmpty } from 'lodash';
  import { CLASSTING_PAY_WEB } from '@/config';

  import PrimeModal from '../components/PrimeModal';
  import CatSubtitle from '../components/CatSubtitle';

  export default {
    name: 'cat-domain',

    data() {
      return {
        busy: false,
        isPrimeModal: false,
        isLicenceModal: false,
      };
    },

    components: {
      PrimeModal,
      CatSubtitle,
    },

    computed: {
      ...mapGetters({
        isSupportedGrade: 'isSupportedGrade',
        catSubjects: 'getCatSubjects',
        catDomains: 'getCatDomains',
        isSubscriptionUser: 'isSubscriptionUser',
        isPrimeSupportCountry: 'isPrimeSupportCountry',
      }),

    },

    methods: {
      ...mapActions([
        'fetchSubjects',
        'fetchCatDomain',
        'creatCatCard',
        'fetchCatConfigs',
        'setBusy',
      ]),

      showPrime() {
        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(CLASSTING_PAY_WEB);
        }

        return window.open(CLASSTING_PAY_WEB);
      },

      okPrimeModal() {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'modal_preview_cat',
          eventAction: 'click',
        });

        this.isPrimeModal = false;
        this.showPrime();
      },

      closePrimeModal() {
        this.isPrimeModal = false;
        return true;
      },

      openLearningViewer(viewerUrl, isFirstCatQuiz) {
        if (!this.isSubscriptionUser && !isFirstCatQuiz) {
          this.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'cat',
            eventAction: 'preview',
          });

          if (this.isPrimeSupportCountry) {
            this.isPrimeModal = true;
            return true;
          }

          this.isLicenceModal = true;
          return true;
        }

        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(viewerUrl);
        }

        const viewer = window.open(viewerUrl);
        const delay = setInterval(() => {
          if (viewer.closed) {
            clearInterval(delay);
            this.fetchCatDomain(this.catSubjects.length);
          }
        }, 1000);

        return true;
      },

      handleCloseClick() {
        this.$refs.modal.hide();
      },

      quizProgressValue(value, total) {
        return Number(((value / total) * 100).toFixed(0));
      },

      openCreatedLearningViewer(domainId, isFirstCatQuiz) {
        this.fetchCatConfigs()
          .then((catConfigs) => {
            if (isFirstCatQuiz) {
              return this.creatCatCard({ domainId, quizCount: catConfigs.first_cat_quiz_count });
            }

            if (this.isSubscriptionUser) {
              return this.creatCatCard({ domainId, quizCount: catConfigs.normal_cat_quiz_count });
            }

            return true;
          })
          .then(data => (
            this.openLearningViewer(data.viewer_url, isFirstCatQuiz)
          ));
      },
    },

    beforeMount() {
      this.busy = true;
      Promise.resolve().then(() => {
        if (isEmpty(this.catSubjects)) {
          return this.fetchSubjects();
        }
        return true;
      })
      .then(() => (
        this.fetchCatDomain(this.catSubjects.length)
      ))
      .then(() => {
        this.busy = false;
      });
    },
  };
</script>

<style lang="scss" scoped>
  $dummy-background-color: rgba(0, 0, 0, 0.1);

  .not-support-grade {
    padding: 24px 14px 24px 14px;

    .title {
      float: left;
      font-size: 18px;
    }

    .sub-title {
      float: right;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .domain {
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    padding: 14px;
    margin: 14px 6px 14px 6px;
    display: inline-block;
    width: 300px;
    position: relative;

    @media (max-width: 375px) {
      width: 186px;
    }

    &:hover {
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
    }

    .domain-subject {
      color: rbga(0, 0, 0, 0.5);

      img {
        width: 24px;
        height: 24px;
      }

      span {
        opacity: 0.5;
        padding: 4px;
      }
    }

    .domain-title {
      padding: 12px 0px 12px 0px;
      font-weight: 500;
      font-size: 16px;
    }

    .domain-score {
      font-size: 14px;
    }

    .domain-action {
      text-align: right;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
    }

    .domain-progress-bar {
      padding: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  .dummy-domain {
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    padding: 14px;
    margin: 14px;
    display: inline-block;
    width: 240px;
    height: 114px;
  
    @media (max-width: 375px) {
      width: 186px;
    }

    .dummy-domain-subject {
      padding: 8px 0px 8px 0px;
      margin: 0px 0px 16px 0px;
      background-color: $dummy-background-color;
    }

    .dummy-domain-title {
      padding: 6px 0px 6px 0px;
      margin: 0px 0px 24px 0px;
      background-color: $dummy-background-color;
    }

    .dummy-domain-action {
      padding: 4px 0px 4px 0px;
      background-color: $dummy-background-color;
    }

  }

  .preview-domain {
    .preview-domain-header {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.6);
      padding: 14px;
    }

    .preview-domain-body {
      img {
        width: 100%
      }
    }

    .preview-domain-footer {
      text-align: center;
      padding: 14px;

      button {
        border-radius: 4px;
        background-color: #00c896;
        color: #ffffff;
        border: 0;
        padding: 2% 22%;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CatDomain.vue?7acd2ce8